//  -*-web-*-
import './App.css';
import { countries, markets, rmarkets, days, rdays } from './Mappings.js';
import { ChartButtons } from './ChartButtons.js';
import { ChartDatePicker } from './ChartDatePicker.js';
import { ChartArea } from './ChartArea.js';
import { ChartSelect } from './ChartSelect.js';
import { ChartMultiSlider } from './ChartMultiSlider.js';
import { ChartSlider } from './ChartSlider.js';
import React from 'react';
import Box from '@material-ui/core/Box';
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";

const theme = createMuiTheme({
    typography: { fontSize: 13, },
    spacing: 4,
});

export class App extends React.Component {
    constructor(props) {
	super(props);
	var state = {
	    history: 60,
	    stdev: 1.0,
	    ma: [10, 50],
	    date: new Date(),
	    matches: 15,
	    match: 30,
	    forecast: 21,
	    market: "US (S&P 500)",
	    country: "USA",
	    url: null,
	    dawn: 2000,
	    size: {width: 800, height: 600}
	};
	state["timeline"] = [-state.history, -state.match, 0, state.forecast];
	state["url"] = this.getUrl(state);
	this.state = state;
	this.getAppState = this.getAppState.bind(this);
	this.debounceFunc = debounce(() => {
	    this.setState({ size: { width: window.innerWidth,
				    height: window.innerHeight }})}).bind(this);
	this.wrapper = React.createRef();
    }
	    
    updateWinSize() {
	this.setState({ size: { width: window.innerWidth,
				height: window.innerHeight }});
    }

    componentDidMount() {
	this.updateWinSize();
	window.addEventListener('resize', this.debounceFunc);
    }
    
    componentWillUnmount() {
	window.removeEventListener('resize', this.debounceFunc);
    }

    getAppState() {
	return this.state;
    }

    getUrl(state) {
	var url = "http://charts.zoteo.com/DB_match.php?showsamples=true" +
		  "&timeweight=0&peakvalleylen=2" +
		  "&win=true&whi=true&days=1&output=plain&cache=true";
	const addArg = function(key, val) {
	    switch(key) {
		case "stdev":
		    let showStdev = val !== null;
		    url += "&showdistribution=" + showStdev;
		    if (showStdev) {
			url += "&std=" + val.toString();
		    }
		    break;
		case "ma":
		    url += "&mav=";
		    var first = true;
		    val.forEach((ma) => {
			first ? first = false : url += ",";
			url += ma.toString();
		    });
		    break;
		case "date":
		    let year = val.getFullYear().toString();
		    let mon = (val.getMonth()+1);
		    let month = mon > 9 ? "" : "0";
		    month += mon.toString();
		    let day = val.getDate() > 9 ? "" : "0";
		    day += val.getDate().toString();
		    let datestring = year + month + day + "t000000";
		    url += "&date=" + datestring;
		    break;
		case "matches":
		    url += "&samples=" + val;
		    break;
		case "match":
		    url += "&matchinglen=" + val;
		    break;
		case "forecast":
		    url += "&forecastlen=" + val;
		    break;
		case "market":
		    url += "&tic=" + rmarkets[val];
		    break;
		case "history":
		    url += "&plen=" + val;
		    break;
		case "dawn":
		    url += "&dawn=" + val;
		    break;
		default:
		    // code block
	    }
	};
	var args = {};
	Object.assign(args, this.state);
	Object.assign(args, state);
	var key, val;
	for([key, val] of Object.entries(args)) {
	    addArg(key, val);
	}
	return url;
    }
    
    stateChange(p, val) {
	var state = {};
	switch(p.kind) {
	    case "stdev":
		state[p.kind] = parseFloat(val);
		break;
	    case "dawn":
	    case "matches":
		state[p.kind] = parseInt(val);
		break;
	    case "ma":
		let ma = [];
		val.forEach((s) => { ma.push(parseInt(s)); });
		state[p.kind] = ma;
		break;
	    case "match":
	    case "forecast":
	    case "history":
		if (isNaN(val)) val = days[val];
		state[p.kind] = val;
		break;
	    case "datedelta":
		let newdate = new Date(this.state.date);
		newdate.setDate(newdate.getDate() + val);
		state["date"] = newdate;
		break;
	    case "timeline":
		state.forecast = val[3] - val[2];
		state.match = val[2] - val[1];
		state.history = val[2] - val[0];
		state.timeline = val;
		break;
	    default:
		state[p.kind] = val;
	}
	state["url"] = this.getUrl(state);
	state["country"] = countries[state.market];
	this.setState(state);
    }
	    
    render() {
	const year = this.state.date.getFullYear();
	const yearStep = 5;
        var yearStart = year - (year % yearStep) + yearStep;
	const yearEnd = 1900;
	const yearNum = Math.trunc((yearStart - yearEnd + 1) / yearStep);
	const items = {
	    "stdev": ["0.5", "1.0", "2.0"],
	    "ma": ["10", "20", "50", "100", "200"],
	    "matches": ["5", "10", "15", "20", "30", "50"],
	    "match": ["3m", "2m", "1m", "3w", "2w", "1w"],
	    "history": ["1y", "6m", "4m", "3m", "2m", "1m"],
	    "forecast": ["1w", "2w", "3w", "1m", "2m"],
	    "presets": ["1w", "2w", "3w", "1m", "2m", "3m"],
	    "market": Object.values(markets),
	    "dawn": Array(yearNum).fill().map(() => yearStart -= yearStep)
	};
	return(
<div className="App">
  <header className="App-header">
    <div style={{ width: '100%' }}>
      <ThemeProvider theme={theme}>
	<Box display="flex" flexWrap="wrap">
          <Box p={1}>
	    {this.renderSelect("market", "Market:", this.state.market, items["market"])}
          </Box>
	  <Box p={2}>
	    {this.renderDateInput()}
	  </Box>
	  <Box p={1}>
	    {this.renderSelect("dawn", "Dawn:", this.state.dawn, items["dawn"])}
	  </Box>
	  <Box p={2}>
	    {this.renderHistory()}
	  </Box>
	</Box>
	<Box display="flex" flexWrap="wrap">
	  <Box p={1}>
	    {this.renderButtons("history", "History:", rdays[this.state.history],
	    items["history"])}
          </Box>
	  <Box p={1}>
	    {this.renderButtons("matches", "Matches:", this.state.matches.toString(),
	    items["matches"], true)}
          </Box>
	  <Box p={1}>
	    {this.renderButtons("match", "Match:", rdays[this.state.match], items["match"], true)}
	  </Box>
	  <Box p={1}>
	    {this.renderButtons("forecast", "Forecast:", rdays[this.state.forecast],
	    items["forecast"], true)}
          </Box>
	  <Box p={1}>
	    {this.renderMultiInput()}
          </Box>
	  <Box>
	    <ChartArea
	      url={this.state.url} size={this.state.size}
	      appState={this.getAppState} />
	  </Box>
	  
	</Box>
	<Box display="flex" flexWrap="wrap">
          <Box p={1}>
	    {this.renderButtons("ma", "MA:", this.state.ma.map(String),
	    items["ma"], false, true)}
          </Box>
	  <Box p={1}>
	    {this.renderButtons("stdev", "Stdev:", "1.0", items["stdev"])}
          </Box>
	</Box>
      </ThemeProvider>
      
    </div>
  </header>
</div>
);
    }

    renderMultiInput() {
	if (true) return null;
	return (
	    <ChartMultiSlider
	    kind="timeline" min={-200} max={100} 
	    size={this.state.size} onClick={(p, v) => this.stateChange(p, v)}
	    val={this.state.timeline} />
	);
    }

    renderHistory() {
	return null;
	//return this.renderSlider("history", "History:", this.state.history, 10, 300, 10);
    }
    
    renderDateInput() {
	return (
	    <ChartDatePicker
	    kind="date" val={this.state.date}
	    realtime={false} country={this.state.country}
	    size={this.state.size} onClick={(p, v) => this.stateChange(p, v)}
	    className="datepicker" />
	);
    }

    renderSlider(kind, label, init, low, high, step) {
	return (
	    <ChartSlider
	    kind={kind} label={label} val={init} min={low} max={high} step={step}
	    size={this.state.size} onClick={(p, v) => this.stateChange(p, v)} />
	);
    }

    renderSelect(kind, label, init, items) {
	return (
	    <ChartSelect
	    kind={kind} label={label} val={init} items={items}
	    size={this.state.size} onClick={(p, v) => this.stateChange(p, v)} />
	);
    }

    renderButtons(kind, label, init, items, radio=false, multiselect=false) {
	return (
	    <ChartButtons
	    kind={kind} label={label} items={items} val={init}
	    radio={radio} multiselect={multiselect}
	    size={this.state.size} onClick={(p, v) => this.stateChange(p, v)} />
	);
    }
}

function debounce(func, timeout=200){
    let timer;
    return (...args) => {
	clearTimeout(timer);
	timer =
	    setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export default App;
